import { gql } from "../../__generated__";

export const GET_EMPLOYER_JOB_ADS =
  gql(`query GetEmployerJobAds($dateFilter: EmployerJobAdsDateFilter, $employmentTypes: [EmploymentType!]!) {
  getEmployerJobAds(dateFilter: $dateFilter, employmentTypes: $employmentTypes)  {
    categories {
      name
    }
    tags {
      id
      name
    }
    companyName
    
    applicationDeadline

    location {
      area
      state
      country
    }
    title
    salary
    salaryDetails {
      starting
      cap
      currencyCode
    }
    id
    principal {
      name
    }
    organization {
      name
    }
    visibility
    employmentType
    createdAt
    description
    hasApplied
    canApply
    duration {
      value
      type
    }
  }
}`);
